import type { ProgressBarLevel } from "@revmatics/catalyst";

export const getPasswordStrength = (password: string): ProgressBarLevel => {
  if (!password) return 0;

  const hasLower = /[a-z]/.test(password);
  const hasUpper = /[A-Z]/.test(password);
  const hasDigit = /[0-9]/.test(password);
  const hasSpecial = /[^A-Za-z0-9]/.test(password);

  const specialCount = (password.match(/[^A-Za-z0-9]/g) || []).length;

  let caseSwitches = 0;
  for (let i = 1; i < password.length; i++) {
    if (
      (/[a-z]/.test(password[i - 1]) && /[A-Z]/.test(password[i])) ||
      (/[A-Z]/.test(password[i - 1]) && /[a-z]/.test(password[i]))
    ) {
      caseSwitches++;
    }
  }

  // Very weak: only digits OR only letters of same case
  if (
    (hasDigit && !hasLower && !hasUpper && !hasSpecial) ||
    (hasLower && !hasUpper && !hasDigit && !hasSpecial) ||
    (hasUpper && !hasLower && !hasDigit && !hasSpecial)
  ) {
    return 1;
  }

  // Weak: letters of different case + digits, no special characters
  if (hasLower && hasUpper && hasDigit && !hasSpecial) {
    return 2;
  }

  // Good: letters of different case + digits + at least one special
  if (hasLower && hasUpper && hasDigit && hasSpecial) {
    // Strong: Good + length > 12 + multiple specials or multiple case switches
    if (password.length > 12 && (specialCount > 1 || caseSwitches > 1)) {
      return 4;
    }
    return 3;
  }

  // Fallback
  return 1;
};
